import { render, staticRenderFns } from "./Demanda.vue?vue&type=template&id=7f560061&scoped=true&"
import script from "./Demanda.vue?vue&type=script&lang=js&"
export * from "./Demanda.vue?vue&type=script&lang=js&"
import style0 from "./Demanda.vue?vue&type=style&index=0&id=7f560061&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.2_cache-loader@4.1.0_webpack@4.28.4_supports-color@6.1.0___css-loader@3_7d6ac29872945af8d84571788ffddadf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f560061",
  null
  
)

export default component.exports